<template>
  <!-- 如果要加回显就把addTarget换成props.target,需让后端
    把接口system/selectUserList多传typeId和roleId -->
  <EditCom
    :target="addTarget"
    :inputList="addInputList"
    :buttonList="addButtonList"
    :rules="addRules"
    :title="props.title"
    @closeFun="closeAdd"
    ref="edit_com"
  />
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref, nextTick, reactive
} from 'vue';
import EditCom from '@/components/EditCom/index.vue'
import { putCustomRegion } from '@/api/Region';
import { message } from '@/utils/js/initVariable'
import { dayjs } from  '@/utils/js/initVariable';

import { queryOrdinaryUserList, } from '@/api/System/UserManager';

const props = defineProps({
  target: {
    type: Object,
    default: () => ({})
  },
  title: {
    type: String,
    default: () => ({})
  }
})

const closeAdd = ()=>{
  emit('close')
}
const queryOrdinaryUserListFn = ()=>{
  queryOrdinaryUserList({}).then(res=>{
    if(res.data.code == 1004){
      addTarget['userList'] = res.data.dataList;
    }
  }).catch(err=>{
    console.log(err);
  });
}

const showFlag = ref(false);

const addSubmit = (form, target, button, loadFn) => {
  form.value.validate((valid) => {
    if (valid) {
      // 构造请求参数（只保留图层相关字段）
      putCustomRegion(target).then((res) => {
        if (res.data.code === 1004) {
          message(`上传成功`, 1)
          closeAdd()
          emit('refresh')
        } else {
          message('操作失败', 0)
        }
      }).catch((err) => {
        console.error(err)
        message('请求失败', 0)
      }).finally(() => {
        loadFn() 
      })
    } else {
      loadFn() 
    }
  })
}
// 组件EditCom
const addTarget = reactive({
  ...props.target,
  polygonUserList: props.target?props.target['userIdList']:[]
})
const addInputList = ref([
  { name: '区域名称', prop: 'polygonName', type: 'text' },
  { 
    name: '区域', 
    prop: 'geom', 
    type: 'mapScopeSign',
    message: { text: '在此处绘制多边形区域' },
    polygon: { oneFlag: true }
  },
  { name: '描述', prop: 'desc', type: 'textarea' },
  { name: '用户', prop: 'polygonUserList', type: 'select',
    select: {
      list: 'userList',
      value: 'userId',
      label: 'userName',
      multiple: true,
      filterable: true,
    }
  },
  { name: '标签', prop: 'tagList', type: 'tags' },
]),
addButtonList = ref([
  { name: '取消', fun: closeAdd, type: 'danger', },
  { name: '确定', fun: addSubmit, type: 'primary', },
]),
addRules = reactive({
  polygonName: [
    { required: true, message: '请输入区域名称', trigger: 'blur' },
  ]
})
const form = ref({
})

const formRef = ref(null)

const eventTypes = ref([])

const emit = defineEmits(['close', 'confirm', 'refresh'])

const editFlag = ref(false)

const close = () => {
  emit('close')
}

onMounted(() => {
  queryOrdinaryUserListFn();
})
</script>

<style lang="less" scoped>
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active in <2.1.8 */ {
  opacity: 0;
}

.additional-info {
  margin-top: 16px;
}
</style>